(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6268],{

/***/ 31353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports seoKeys, emptySeo */
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var seoKeys = {// NotFound: "notFound",
  // Homepage: "homePage",
  // firstHand: `firstHand_`, // use with car id. example: {firstHand_122123}
  // zeroKm: "zeroKm_", // use with car slug. example: {zeroKm_14/629/271/2021}
  // leasing: "leasing_", // use with car slug. example: {leasing_14/629/271/2021}
};

for (var key in seoKeys) {
  seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}

var emptySeo = {
  title: " ",
  description: "",
  keywords: ""
};

var SeoMetaData = function SeoMetaData(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
      title: data.title,
      description: data.description || "",
      additionalMetaTags: [{
        name: "title",
        content: data.title
      }, {
        name: "keywords",
        content: data.keywords
      }, {
        name: "description",
        content: data.description
      }],
      openGraph: {
        title: data.title,
        description: data.description || ""
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SeoMetaData));

/***/ }),

/***/ 5247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div").withConfig({
  displayName: "DiscountPromo__StyledContainer",
  componentId: "sc-ei00og-0"
})(["display:flex;align-items:center;padding:8px;border-radius:4px;border:1px solid #ffbc0d;background:#fffaeb;width:fit-content;min-height:36px;"]);
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
  displayName: "DiscountPromo__StyledText",
  componentId: "sc-ei00og-1"
})(["color:#000;font-family:NarkisBlock;font-size:18px;font-style:normal;font-weight:400;line-height:normal;letter-spacing:0.27px;display:flex;align-items:center;"]);

var DiscountPromo = function DiscountPromo(_ref) {
  var promoText = _ref.promoText;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledContainer, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledText, {
      children: promoText
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DiscountPromo);

/***/ }),

/***/ 44203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "KeyboardNavigation__StyledContainer",
  componentId: "sc-mrb9q4-0"
})(["display:", ";position:fixed;z-index:1500;margin:0 auto;width:100%;", "{top:10px;}"], function (p) {
  return p !== null && p !== void 0 && p.hidden ? "none" : "block";
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledNavContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "KeyboardNavigation__StyledNavContainer",
  componentId: "sc-mrb9q4-1"
})(["padding:15px;background:", ";border:3px solid ", ";border-radius:3px;"], function (p) {
  return p.theme.colors.grey;
}, function (p) {
  return p.theme.colors.cherryRed;
});
var StyledDescription = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "KeyboardNavigation__StyledDescription",
  componentId: "sc-mrb9q4-2"
})(["text-align:center;font-size:25px;margin:0;padding:0;"]);

var KeyboardNavigation = function KeyboardNavigation(_ref) {
  var refList = _ref.refList;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      hideNav = _useState[0],
      setHideNav = _useState[1]; // Ensures that this component will only show once


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      seenOnce = _useState2[0],
      setSeenOnce = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function handleKeyDown(e) {
      if (!(e !== null && e !== void 0 && e.key) || seenOnce) return;

      if (e.key === "Tab") {
        e.preventDefault();

        if (hideNav) {
          setHideNav(false);
          return;
        }

        if (!hideNav) {
          setSeenOnce(true);
          setHideNav(true);
          return;
        }
      }

      if (!hideNav && e.key === "Enter") {
        var _refList$, _refList$$current, _refList$2, _refList$2$current;

        (_refList$ = refList[0]) === null || _refList$ === void 0 ? void 0 : (_refList$$current = _refList$.current) === null || _refList$$current === void 0 ? void 0 : _refList$$current.scrollIntoView();
        (_refList$2 = refList[0]) === null || _refList$2 === void 0 ? void 0 : (_refList$2$current = _refList$2.current) === null || _refList$2$current === void 0 ? void 0 : _refList$2$current.focus();
        setSeenOnce(true);
        setHideNav(!hideNav);
      } // Old code that allowed you to navigate to different blocks
      // matches digits 0 - 9
      // if (!hideNav && e.key.match(/^\d+$/)) {
      // refList[e.key - 1]?.current?.scrollIntoView()
      // refList[e.key - 1]?.current?.focus()
      // }

    }

    document.addEventListener("keydown", handleKeyDown); // Clean up event

    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [hideNav]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
    hidden: hideNav,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledNavContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDescription, {
        children: "\u05D3\u05DC\u05D2 \u05DC\u05EA\u05D5\u05DB\u05DF"
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (KeyboardNavigation);

/***/ }),

/***/ 16110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["href", "passHref", "children", "openInNewTab", "noScrollToTop", "ariaLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var NextLink = function NextLink(_ref) {
  var href = _ref.href,
      passHref = _ref.passHref,
      children = _ref.children,
      _ref$openInNewTab = _ref.openInNewTab,
      openInNewTab = _ref$openInNewTab === void 0 ? false : _ref$openInNewTab,
      _ref$noScrollToTop = _ref.noScrollToTop,
      noScrollToTop = _ref$noScrollToTop === void 0 ? false : _ref$noScrollToTop,
      ariaLabel = _ref.ariaLabel,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  // const { asPath } = useRouter()
  // const idx = asPath.indexOf("?")
  // const search = idx >= 0 ? asPath.slice(idx) : undefined
  // const link: UrlObject = {
  //   pathname: href,
  //   // search
  //  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: href,
    passHref: true,
    scroll: !noScrollToTop,
    children: openInNewTab ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({
      target: "_blank",
      rel: "noreferrer"
    }, props), {}, {
      "aria-label": ariaLabel,
      children: children
    })) : passHref ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({}, props), {}, {
      "aria-label": ariaLabel,
      children: children
    }))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(NextLink));

/***/ }),

/***/ 37364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16835);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85161);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64436);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82175);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50066);
/* harmony import */ var _Bit_Form_FormikInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60137);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var _excluded = ["name", "label", "type", "required", "placeholder", "maxLength", "numeric", "InputProps", "centerField", "autoFocus", "topMargin", "mobileTopMargin"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import ErrorIcon from "components/Icons/ErrorIcon"




var Styled = {
  Field: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_1__.Field).withConfig({
    displayName: "FormInput__Field",
    componentId: "sc-kr1sqg-0"
  })(["width:100%;.MuiFormHelperText-root{font-size:20px;}.MuiFormHelperText-root.Mui-error{", ";}input{", "}"], function (p) {
    return p.$center ? "text-align: center;" : "";
  }, function (p) {
    return p.$center ? "text-align: center;" : "";
  }),
  FormControl: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    displayName: "FormInput__FormControl",
    componentId: "sc-kr1sqg-1"
  })(["display:flex;", "{width:100%;}"], function (p) {
    return p.theme.breakpoints.down("sm");
  }),
  FieldWrapper: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormInput__FieldWrapper",
    componentId: "sc-kr1sqg-2"
  })(["margin-top:", ";input{font-family:Speedee,NarkisBlock,sans-serif;color:#000;font-size:20px;font-weight:500;}input[type=\"email\"]{font-size:16px;font-family:sans-serif,Speedee;font-weight:normal;}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;}.MuiOutlinedInput-root.Mui-error{fieldset{box-shadow:none;border:1px solid rgba(215,2,2,0.5);top:0;}}.MuiOutlinedInput-root{box-shadow:none;border-radius:8px;border:1px #e5e5e5 solid;background:var(--White,#fff);}", "{", " fieldset{min-height:50px;}}"], function (p) {
    return p.$topMargin ? "".concat(p.$topMargin, "px") : "28px";
  }, function (p) {
    return p.theme.breakpoints.down("sm");
  }, function (p) {
    return (p === null || p === void 0 ? void 0 : p.$mobileTopMargin) && "margin-top: ".concat(p.$mobileTopMargin, "px;");
  }),
  LabelWrapper: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormInput__LabelWrapper",
    componentId: "sc-kr1sqg-3"
  })(["display:flex;align-items:center;"]),
  InputLabel: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "FormInput__InputLabel",
    componentId: "sc-kr1sqg-4"
  })(["transform:none !important;font-size:18px;color:", ";font-weight:400;", ";line-height:1.44;margin-top:5px;"], function (p) {
    return p.theme.colors.darkGrey;
  }, function (p) {
    return p.$center ? "width: 100%; right: none; text-align: center;" : "";
  }),
  BottomText: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    variant: "body1"
  }).withConfig({
    displayName: "FormInput__BottomText",
    componentId: "sc-kr1sqg-5"
  })(["text-align:start;font-size:15px;margin-top:-23px;color:", ";"], function (p) {
    return p.theme.colors.marbleGrey;
  })
};

var FormInput = function FormInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      placeholder = _ref.placeholder,
      maxLength = _ref.maxLength,
      numeric = _ref.numeric,
      InputProps = _ref.InputProps,
      centerField = _ref.centerField,
      autoFocus = _ref.autoFocus,
      topMargin = _ref.topMargin,
      mobileTopMargin = _ref.mobileTopMargin,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_1__.useField)(name),
      _useField2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_useField, 1),
      field = _useField2[0];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Styled.FormControl, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Styled.FieldWrapper, {
      $topMargin: topMargin,
      $mobileTopMargin: mobileTopMargin,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Bit_Form_FormikInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
        name: name,
        type: type,
        required: required,
        placeholder: placeholder,
        maxLength: maxLength,
        numeric: numeric,
        centerField: centerField,
        InputProps: InputProps,
        autoFocus: autoFocus,
        label: label
      }, field), props))
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FormInput);

/***/ }),

/***/ 24300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _giftcardName_; }
});

// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(31353);
// EXTERNAL MODULE: ./components/KeyboardNavigation/KeyboardNavigation.tsx
var KeyboardNavigation = __webpack_require__(44203);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(91315);
// EXTERNAL MODULE: ./common/MediaQueries.tsx
var MediaQueries = __webpack_require__(1438);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(56934);
// EXTERNAL MODULE: ./components/BackButton/BackButton.tsx
var BackButton = __webpack_require__(36166);
// EXTERNAL MODULE: ./components/GenericButton/GenericButton.tsx
var GenericButton = __webpack_require__(92208);
// EXTERNAL MODULE: ./components/Reusable/Bit/Form/FormikForm.tsx
var FormikForm = __webpack_require__(34968);
// EXTERNAL MODULE: ./components/Reusable/Functions/Functions.ts
var Functions = __webpack_require__(64416);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./components/PurchasePage/Calendar.tsx + 1 modules
var Calendar = __webpack_require__(23357);
// EXTERNAL MODULE: ./components/DiscountPromo/DiscountPromo.tsx
var DiscountPromo = __webpack_require__(5247);
// EXTERNAL MODULE: ./components/Reusable/Bit/SingleButtonSelection.tsx
var SingleButtonSelection = __webpack_require__(26490);
// EXTERNAL MODULE: ./components/Reusable/FormsComp/FormInput.tsx
var FormInput = __webpack_require__(37364);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./components/PurchasePage/PurchaseContext.tsx
var PurchaseContext = __webpack_require__(33574);
// EXTERNAL MODULE: ./components/PurchasePage/Texts/HeadingText.tsx
var HeadingText = __webpack_require__(22368);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/PurchasePage/GIftCardAmount.tsx













var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GIftCardAmount__StyledButton",
  componentId: "sc-1oqax4v-0"
})(["width:", ";height:40px;display:flex;justify-content:center;align-items:center;border-radius:8px;border:1px solid ", ";background:var(--White,#fff);margin-top:12px;margin-left:10px;color:", ";font-size:22px;font-family:\"NarkisBlock-Thin\",sans-serif;font-weight:", ";", "{width:", ";height:50px;}:hover{border:2px solid var(--Grey,#757575);}"], function (p) {
  return p.$otherAmount ? "140px" : "110px";
}, function (p) {
  return p.$isSelected ? "var(--Yellow, #FFBC0D)" : "#e5e5e5";
}, function (p) {
  return p.$isSelected ? "#264f36" : "#757575";
}, function (p) {
  return p.$isSelected ? "bold" : "normal";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.$otherAmount ? "97px" : "71px";
});
var StyledLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "GIftCardAmount__StyledLabel",
  componentId: "sc-1oqax4v-1"
})(["cursor:pointer;width:100%;height:100%;:focus{outline:none;> div{border:1px solid ", ";}}"], function (p) {
  return p.theme.colors.darkGrey;
});
var StyledError = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "GIftCardAmount__StyledError",
  componentId: "sc-1oqax4v-2"
})(["margin:0;padding:0;text-align:right;color:#d70202;font-size:18px;line-height:1;", "{position:absolute;bottom:0;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var InputWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GIftCardAmount__InputWrapper",
  componentId: "sc-1oqax4v-3"
})(["margin-top:30px;", "{width:71px;.MuiFormHelperText-root{width:150px;}}", "{margin-top:12px;}.MuiOutlinedInput-root{width:71px;height:50px;border-radius:8px;border:1px #e5e5e5 solid;background:var(--White,#fff);", "{height:40px;width:110px;}}fieldset{top:0;height:40px;}label{line-height:1;transform:translate(-7px,14px) scale(1);", "{transform:translate(-22px,10px) scale(1);}color:#757575 !important;}input{color:#264f36;font-size:22px;font-weight:bold;", "{padding:0px;text-align:center;}transform:translate(9px,7px);}.MuiInputLabel-outlined.MuiInputLabel-shrink{transform:translate(-8px,4px) scale(0.75);}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GIftCardAmount__StyledBox",
  componentId: "sc-1oqax4v-4"
})(["position:relative;", "{div{:nth-child(2){flex-wrap:nowrap;}}button{margin-left:15px;width:110px;}}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledTextWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GIftCardAmount__StyledTextWrapper",
  componentId: "sc-1oqax4v-5"
})(["", "{display:flex;align-items:center;gap:10px;h4{font-size:24px;}}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledSingleButtonSelection = (0,styled_components_browser_esm/* default */.ZP)(SingleButtonSelection/* default */.Z).withConfig({
  displayName: "GIftCardAmount__StyledSingleButtonSelection",
  componentId: "sc-1oqax4v-6"
})(["input:focus-visible + label div{outline:auto 2px Highlight;outline:auto 5px -webkit-focus-ring-color;}"]);
var StyledButtonWrappers = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GIftCardAmount__StyledButtonWrappers",
  componentId: "sc-1oqax4v-7"
})(["display:flex;flex-direction:column;", "{flex-direction:row;flex-wrap:wrap;}"], function (p) {
  return p.theme.breakpoints.up("md");
});

var GiftCardAmount = function GiftCardAmount(_ref) {
  var setAmountError = _ref.setAmountError,
      amountError = _ref.amountError,
      setQuantity = _ref.setQuantity,
      amounts = _ref.amounts,
      maxAmuont = _ref.maxAmuont,
      minAmount = _ref.minAmount,
      amountRef = _ref.amountRef,
      noValueValidation = _ref.noValueValidation,
      setNoValueValidation = _ref.setNoValueValidation,
      validateForm = _ref.validateForm,
      purchaseData = _ref.purchaseData,
      promotion = _ref.promotion;
  var formikProps = (0,formik_esm.useFormikContext)();

  var _usePurchaseContext = (0,PurchaseContext/* usePurchaseContext */.AX)(),
      setOtherAmount = _usePurchaseContext.setOtherAmount,
      otherAmount = _usePurchaseContext.otherAmount;

  var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();

  var _useState = (0,react.useState)(true),
      isDisabled = _useState[0],
      setIsDisabled = _useState[1];

  var _useState2 = (0,react.useState)(""),
      value = _useState2[0],
      setValue = _useState2[1];

  (0,react.useEffect)(function () {
    if (noValueValidation) {
      setAmountError("יש לבחור סכום");
    } else {
      setAmountError("");
    }
  }, [noValueValidation]);

  var checkAmountOnChange = function checkAmountOnChange(number) {
    var quantity = formikProps.values.quantity === 0 ? 1 : formikProps.values.quantity;

    if (quantity * number > maxAmuont) {
      setAmountError("\u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05DB\u05E0\u05D9\u05E1 \u05E1\u05DB\u05D5\u05DD \u05DE\u05E7\u05E1\u05D9\u05DE\u05DC\u05D9 \u05E9\u05DC \u05E2\u05D3 ".concat(maxAmuont, " \u05E9\u05F4\u05D7"));
    } else if (quantity * number < minAmount) {
      setAmountError("\u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05DB\u05E0\u05D9\u05E1 \u05E1\u05DB\u05D5\u05DD \u05DE\u05D9\u05E0\u05D9\u05DE\u05DC\u05D9 \u05E9\u05DC \u05DC\u05E4\u05D7\u05D5\u05EA ".concat(minAmount, " \u05E9\u05F4\u05D7"));
    } else {
      setAmountError("");
    }
  };

  var handleButtonClick = function handleButtonClick(number) {
    setTimeout(function () {
      validateForm();
    }, 500);
    setValue("");
    setNoValueValidation(false);
    setIsDisabled(true);

    if (number === -1) {
      setOtherAmount(true);
      setAmountError("");
    } else {
      setOtherAmount(false);
    }

    if (formikProps.values.quantity === 0) {
      formikProps.setFieldValue("quantity", 1);
      setQuantity(1);
    }

    if (number !== -1) {
      formikProps.setFieldValue("amount", number);
      checkAmountOnChange(number);
    } else formikProps.setFieldValue("amount", "");
  };

  var checkValidation = function checkValidation(e) {
    var enteredValue = e.target.value.replace(/[₪]/g, ""); // Remove the currency symbol (₪)

    if (enteredValue > maxAmuont || formikProps.values.quantity * enteredValue > maxAmuont) {
      setAmountError("\u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05DB\u05E0\u05D9\u05E1 \u05E1\u05DB\u05D5\u05DD \u05DE\u05E7\u05E1\u05D9\u05DE\u05DC\u05D9 \u05E9\u05DC \u05E2\u05D3 ".concat(maxAmuont, " \u05E9\u05F4\u05D7"));
    } else if (enteredValue < minAmount || formikProps.values.quantity * enteredValue < minAmount) {
      setAmountError("\u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05DB\u05E0\u05D9\u05E1 \u05E1\u05DB\u05D5\u05DD \u05DE\u05D9\u05E0\u05D9\u05DE\u05DC\u05D9 \u05E9\u05DC \u05DC\u05E4\u05D7\u05D5\u05EA ".concat(minAmount, " \u05E9\u05F4\u05D7"));
    } else {
      setAmountError("");
    }
  };

  var isNumber = function isNumber(evt) {
    //only allow numbers
    var charCode = evt.which ? evt.which : evt.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    } else {
      if (formikProps.values.quantity === 0) {
        formikProps.setFieldValue("quantity", 1);
        setQuantity(1);
      }
    }
  };

  var formatCurrency = function formatCurrency(value) {
    var currencySymbol = "₪";
    if (value.length === 0) return "";

    if (value.toString().startsWith(currencySymbol)) {
      return value; // Value already has the currency symbol, no need to modify
    }

    return "".concat(currencySymbol).concat(value); // Append the currency symbol (₪) to the value
  };

  (0,react.useEffect)(function () {
    getValue();
  }, []);

  var getValue = function getValue() {
    var amount = purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.amount;

    if (amount) {
      if (!amounts.includes(amount)) {
        setIsDisabled(false);
        setValue(formatCurrency(amount));
      } else {
        setValue("");
      }
    } else {
      setIsDisabled(true);
      setValue("");
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledBox, {
    marginTop: "30px",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTextWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeadingText/* default */.Z, {
        text: "\u05DB\u05DE\u05D4 \u05D1\u05D0 \u05DC\u05DA \u05DC\u05EA\u05EA?"
      }), " ", promotion && /*#__PURE__*/(0,jsx_runtime.jsx)(DiscountPromo/* default */.Z, {
        promoText: promotion
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButtonWrappers, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledSingleButtonSelection, {
        id: "amount",
        items: amounts === null || amounts === void 0 ? void 0 : amounts.filter(function (amount) {
          return amount !== -1;
        }).map(function (amount) {
          return {
            value: amount,
            name: "\u20AA".concat(amount)
          };
        }),
        onSelect: function onSelect(code) {
          return handleButtonClick(code);
        },
        gap: 15,
        noFocus: true,
        itemsPerRow: isDesktop ? 5 : "auto",
        selectedValue: otherAmount ? -1 : formikProps.values.amount > 0 ? formikProps.values.amount : -2,
        customButton: function customButton(radioId, isSelected, item) {
          var isOtherAmount = item.value === -1 || item.value === 5;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLabel, {
              htmlFor: radioId,
              $activeButton: isSelected,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
                $isSelected: isSelected,
                $otherAmount: isOtherAmount,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: item.name
                })
              })
            })
          });
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputWrapper, {
        $focused: !isDisabled,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
          name: "amount",
          label: "\u05E1\u05DB\u05D5\u05DD \u05D0\u05D7\u05E8",
          type: "text",
          onBlurCapture: function onBlurCapture(e) {
            return checkValidation(e);
          },
          onKeyUp: function onKeyUp(e) {
            return isNumber(e);
          },
          maxLength: 5,
          numeric: true,
          id: "input-amount",
          innerRef: amountRef,
          onFocusCapture: function onFocusCapture() {
            formikProps.setFieldValue("amount", "");
          },
          onClick: function onClick() {
            setIsDisabled(false);
          },
          value: isDisabled ? value : formatCurrency(formikProps.values.amount),
          topMargin: "0"
        })
      })]
    }), amountError.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledError, {
      "aria-describedby": "input-amount",
      children: amountError
    })]
  });
};

/* harmony default export */ var GIftCardAmount = (GiftCardAmount);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/PurchasePage/GiftCardInfo.tsx






var GiftCardInfo_StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GiftCardInfo__StyledBox",
  componentId: "sc-1s06eml-0"
})(["svg{position:absolute;top:66px;right:16px;z-index:1;cursor:pointer;circle{fill:white;}}", "{display:flex;flex-direction:column;order:1;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "GiftCardInfo__StyledWrapper",
  componentId: "sc-1s06eml-1"
})(["display:flex;justify-content:flex-end;width:", ";img{border-radius:5px;}", "{width:100%;height:", ";position:relative;margin-right:0px;img{border-radius:0px;}}"], function (p) {
  return p.$isaiimage ? "400px" : "450px";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.$isaiimage ? "440px" : "260px";
});

var GiftCardInfo = function GiftCardInfo(_ref) {
  var _localStorage, _giftCard$image, _giftCard$image2;

  var giftCard = _ref.giftCard;
  var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
  var router = (0,next_router.useRouter)();
  var isAiImage =  true && (giftCard === null || giftCard === void 0 ? void 0 : giftCard.isAiImage) && ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("imageAiUrl")) && (giftCard === null || giftCard === void 0 ? void 0 : giftCard.slug) === JSON.parse(localStorage.getItem("slugAi"));
  var imageUrl = isAiImage ? JSON.parse(localStorage.getItem("imageAiUrl")) : giftCard === null || giftCard === void 0 ? void 0 : (_giftCard$image = giftCard.image) === null || _giftCard$image === void 0 ? void 0 : _giftCard$image.imageUrl;
  var imageAlt = isAiImage ? "" : giftCard === null || giftCard === void 0 ? void 0 : (_giftCard$image2 = giftCard.image) === null || _giftCard$image2 === void 0 ? void 0 : _giftCard$image2.imageUrl;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardInfo_StyledBox, {
    onClick: function onClick() {
      return isDesktop ? {} : router.back();
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledWrapper, {
      $isaiimage: isAiImage,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: imageUrl,
        alt: imageAlt,
        layout: !isDesktop ? "fill" : "fixed",
        width: isAiImage ? isDesktop && "400px" : isDesktop && "435px",
        height: isAiImage ? isDesktop && "440px" : isDesktop && "285px"
      })
    })
  });
};

/* harmony default export */ var PurchasePage_GiftCardInfo = (GiftCardInfo);
;// CONCATENATED MODULE: ./components/PurchasePage/GiftCardScheduler/GiftCardEndTime.tsx








var GiftCardEndTime_StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GiftCardEndTime__StyledBox",
  componentId: "sc-1hf2537-0"
})(["margin-top:30px;position:relative;> div{margin-top:20px;}", "{margin-top:20px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var GiftCardEndTime_StyledError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "GiftCardEndTime__StyledError",
  componentId: "sc-1hf2537-1"
})(["color:#d70202;font-size:18px;line-height:1;text-align:right;position:absolute;bottom:-20px;"]);

var GiftCardEndTime = function GiftCardEndTime(_ref) {
  var scheduleEndTime = _ref.scheduleEndTime,
      setScheduleEndTime = _ref.setScheduleEndTime,
      frequency = _ref.frequency,
      scheduleStartTime = _ref.scheduleStartTime,
      scheduleError = _ref.scheduleError;

  var _useState = (0,react.useState)(null),
      minDate = _useState[0],
      setMinDate = _useState[1];

  (0,react.useEffect)(function () {
    setAvailableDates();
  }, [frequency, scheduleStartTime]);

  var getWeekDays = function getWeekDays(date) {
    var minSelectableDate = new Date(scheduleStartTime);
    var selectedDay = minSelectableDate.getDay(); // Set to one week (7 days) after the start date

    var dayOfWeek = date.getDay();
    return dayOfWeek === selectedDay && date.getTime() > minSelectableDate.getTime();
  };

  var setAvailableDates = function setAvailableDates() {
    var minSelectableDate = new Date(scheduleStartTime);

    if (frequency === "Daily") {
      setMinDate(minSelectableDate.setDate(minSelectableDate.getDate() + 1));
    }

    if (frequency === "Weekly") {
      var oneWeekLater = minSelectableDate;
      oneWeekLater.setDate(oneWeekLater.getDate() + 7);
      setMinDate(oneWeekLater);
    }

    if (frequency === "Monthly") {
      var oneMonthLater = minSelectableDate;
      oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);

      if (oneMonthLater.getDate() !== new Date(scheduleStartTime).getDate()) {
        oneMonthLater.setMonth(new Date(scheduleStartTime).getMonth() + 1);
      }

      setMinDate(oneMonthLater);
    }

    if (frequency === "Yearly") {
      var oneYearLater = minSelectableDate;
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

      if (oneYearLater.getMonth() !== new Date(scheduleStartTime).getMonth()) {
        oneYearLater.setMonth(minSelectableDate.getMonth() - 1);
      }

      setMinDate(oneYearLater);
    }
  };

  var isYearInEnabledRange = function isYearInEnabledRange(date) {
    var startDate = new Date(scheduleStartTime);
    var nextYearStartDate = new Date(date.getFullYear(), date.getMonth(), startDate.getDate());

    if (nextYearStartDate.getMonth() === date.getMonth()) {
      // The start date exists in the next year, select the same date
      return startDate.getDate() === date.getDate() && date.getMonth() === startDate.getMonth() && startDate.getFullYear() !== date.getFullYear();
    } else {
      // The start date doesn't exist in the next year, select the last day of the same month in the next year
      var lastDayOfNextYear = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return date.getDate() === lastDayOfNextYear.getDate() && date.getMonth() === startDate.getMonth() && startDate.getFullYear() !== date.getFullYear();
    }
  };

  var getMonthDates = function getMonthDates(date) {
    var startDate = new Date(scheduleStartTime);
    var nextMonthStartDate = new Date(date.getFullYear(), date.getMonth(), startDate.getDate());

    if (nextMonthStartDate.getMonth() === date.getMonth()) {
      // The start date exists in the next month, select the same date
      return startDate.getDate() === date.getDate() && date.getTime() > startDate.getTime();
    } else {
      // The start date doesn't exist in the next month, select the last day of the next month
      var lastDayOfNextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return date.getDate() === lastDayOfNextMonth.getDate() && date.getTime() > startDate.getTime();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(GiftCardEndTime_StyledBox, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeadingText/* default */.Z, {
      text: "\u05D4\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D4\u05D0\u05D7\u05E8\u05D5\u05DF \u05D9\u05E9\u05DC\u05D7 \u05D1\u05EA\u05D0\u05E8\u05D9\u05DA:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar/* default */.Z, {
      date: scheduleEndTime,
      setDate: setScheduleEndTime,
      minDate: minDate,
      filterDate: frequency === "Weekly" ? getWeekDays : frequency === "Yearly" ? isYearInEnabledRange : frequency === "Monthly" ? getMonthDates : null,
      type: "endTime",
      disabled: !scheduleStartTime || !frequency
    }), scheduleError && !scheduleEndTime && /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardEndTime_StyledError, {
      children: scheduleError
    })]
  });
};

/* harmony default export */ var GiftCardScheduler_GiftCardEndTime = (GiftCardEndTime);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(75741);
;// CONCATENATED MODULE: ./components/PurchasePage/GiftCardScheduler/GiftCardFrequency.tsx









var GiftCardFrequency_StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GiftCardFrequency__StyledBox",
  componentId: "sc-vkh9ve-0"
})(["margin-top:30px;position:relative;", "{margin-top:20px;}> div{margin-top:20px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GiftCardFrequency__StyledButtonWrapper",
  componentId: "sc-vkh9ve-1"
})(["button{padding-left:10px;", "{width:25%;:last-child{padding-left:0px;}}}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var GiftCardFrequency_StyledLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "GiftCardFrequency__StyledLabel",
  componentId: "sc-vkh9ve-2"
})(["cursor:pointer;width:100%;height:100%;:focus{outline:none;}"]);
var GiftCardFrequency_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GiftCardFrequency__StyledButton",
  componentId: "sc-vkh9ve-3"
})(["width:70px;height:50px;background-color:#f7f7f7;color:", ";border:", ";display:flex;justify-content:center;align-items:center;font-family:\"NarkisBlock\";font-size:24px;font-weight:bold;", "{width:100%;height:46px;margin-left:10px;line-height:23px;}:hover{border:1px solid ", ";}"], function (p) {
  return p.$isSelected ? "#264F36" : "#757575";
}, function (p) {
  return p.$isSelected ? "1px solid #264F36" : "none";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, colors/* default.darkGreen */.Z.darkGreen);
var GiftCardFrequency_StyledError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "GiftCardFrequency__StyledError",
  componentId: "sc-vkh9ve-4"
})(["color:#d70202;font-size:18px;line-height:1;text-align:right;position:absolute;bottom:-20px;"]);

var GiftCardFrequency = function GiftCardFrequency(_ref) {
  var setFrequency = _ref.setFrequency,
      scheduleError = _ref.scheduleError,
      frequency = _ref.frequency,
      setScheduleEndTime = _ref.setScheduleEndTime;
  var buttons = [{
    value: "Daily",
    text: "כל יום"
  }, {
    value: "Weekly",
    text: "כל שבוע"
  }, {
    value: "Monthly",
    text: "כל חודש"
  }, {
    value: "Yearly",
    text: "כל שנה"
  }];

  var handleButtonClick = function handleButtonClick(code) {
    setFrequency(code);
    setScheduleEndTime(null);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(GiftCardFrequency_StyledBox, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeadingText/* default */.Z, {
      text: "\u05DB\u05DC \u05DB\u05DE\u05D4 \u05D6\u05DE\u05DF \u05DC\u05D7\u05D3\u05E9 \u05D0\u05EA \u05E9\u05DC\u05D9\u05D7\u05EA \u05D3\u05DE\u05D9 \u05D4\u05DB\u05D9\u05E1?"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButtonWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SingleButtonSelection/* default */.Z, {
        id: "scheduleSelect",
        items: buttons.map(function (amount) {
          return {
            value: amount.value,
            name: amount.text
          };
        }),
        noFocus: true,
        onSelect: function onSelect(code) {
          return handleButtonClick(code);
        },
        gap: 15,
        itemsPerRow: "auto",
        allowEmpty: true,
        selectedValue: frequency,
        customButton: function customButton(radioId, isSelected, item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardFrequency_StyledLabel, {
              htmlFor: radioId,
              $activeButton: isSelected,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardFrequency_StyledButton, {
                $isSelected: isSelected,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: item.name
                })
              })
            })
          });
        }
      })
    }), scheduleError && !frequency && /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardFrequency_StyledError, {
      children: scheduleError
    })]
  });
};

/* harmony default export */ var GiftCardScheduler_GiftCardFrequency = (GiftCardFrequency);
// EXTERNAL MODULE: ./components/PurchasePage/GiftCardScheduler/GiftCardScheduler.tsx
var GiftCardScheduler = __webpack_require__(60166);
;// CONCATENATED MODULE: ./components/PurchasePage/GiftCardScheduler/GiftCardStartTime.tsx







var GiftCardStartTime_StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GiftCardStartTime__StyledBox",
  componentId: "sc-khsss2-0"
})(["margin-top:30px;position:relative;> div{margin-top:20px;}.react-datepicker-wrapper{border:", " !important;}", "{margin-top:20px;}"], function (p) {
  return p.$pastTimeError ? "1px solid rgba(215, 2, 2, 0.5)" : "none";
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var GiftCardStartTime_StyledError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "GiftCardStartTime__StyledError",
  componentId: "sc-khsss2-1"
})(["color:#d70202;font-size:18px;line-height:1;text-align:right;position:absolute;bottom:-20px;"]);

var GiftCardStartTime = function GiftCardStartTime(_ref) {
  var setScheduleStartTime = _ref.setScheduleStartTime,
      scheduleStartTime = _ref.scheduleStartTime,
      scheduleError = _ref.scheduleError,
      setScheduleEndTime = _ref.setScheduleEndTime,
      pastTimeError = _ref.pastTimeError;

  var handleTimeChange = function handleTimeChange() {
    setScheduleEndTime(null);
  };

  var getAvailableDates = function getAvailableDates(date) {
    var currentDate = new Date();
    var thresholdHour = 23;
    var thresholdMinute = 45;
    if (currentDate.getHours() === thresholdHour && currentDate.getMinutes() > thresholdMinute) return new Date(date) > new Date();
    return true;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(GiftCardStartTime_StyledBox, {
    $pastTimeError: pastTimeError,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeadingText/* default */.Z, {
      text: "\u05D4\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D4\u05E8\u05D0\u05E9\u05D5\u05DF \u05D9\u05E9\u05DC\u05D7 \u05D1\u05EA\u05D0\u05E8\u05D9\u05DA:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar/* default */.Z, {
      date: scheduleStartTime,
      setDate: setScheduleStartTime,
      type: "startTime",
      handleTimeChange: handleTimeChange,
      setEndTime: setScheduleEndTime,
      filterDate: getAvailableDates
    }), scheduleError && !scheduleStartTime && /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardStartTime_StyledError, {
      children: scheduleError
    })]
  });
};

/* harmony default export */ var GiftCardScheduler_GiftCardStartTime = (GiftCardStartTime);
;// CONCATENATED MODULE: ./components/PurchasePage/GiftCardScheduler/GiftCardStaticText.tsx




var GiftCardStaticText = function GiftCardStaticText(_ref) {
  var _ref$amount = _ref.amount,
      amount = _ref$amount === void 0 ? 0 : _ref$amount,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 1 : _ref$quantity;
  var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body1"
  }).withConfig({
    displayName: "GiftCardStaticText__StyledText",
    componentId: "sc-11l16py-0"
  })(["text-align:right;line-height:26px;span{font-weight:bold;font-family:NarkisBlock;}", "{width:680px;}"], function (p) {
    return p.theme.breakpoints.up("md");
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledText, {
    children: ["\u05D1\u05D7\u05E8\u05D5 \u05D1\u05D0\u05D5\u05E4\u05E6\u05D9\u05D4 \u05D4\u05D6\u05D0\u05EA \u05D0\u05DD \u05EA\u05E8\u05E6\u05D5 \u05DC\u05E9\u05DC\u05D5\u05D7", " ", quantity <= 1 ? "גיפטקארד" : "גיפטקארדים", " \u05D1\u05E1\u05DB\u05D5\u05DD \u05E9\u05DC", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      children: [" ", parseInt(amount.toString().replace(/[₪]/g, "")) * quantity ? parseInt(amount.toString().replace(/[₪]/g, "")) * quantity : 0, " ", "\u05E9\"\u05D7"]
    }), " ", "\u05DB\u05DC \u05EA\u05E7\u05D5\u05E4\u05EA \u05D6\u05DE\u05DF \u05E7\u05D1\u05D5\u05E2\u05D4. \u05D4\u05D7\u05D9\u05D5\u05D1 \u05D4\u05E8\u05D0\u05E9\u05D5\u05DF \u05D9\u05D1\u05D5\u05E6\u05E2 \u05D1\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05E8\u05D0\u05E9\u05D5\u05DF \u05E9\u05EA\u05D1\u05D7\u05E8\u05D5 \u05D5\u05D1\u05D4\u05EA\u05D0\u05DD \u05DC\u05EA\u05D3\u05D9\u05E8\u05D5\u05EA \u05D4\u05E0\u05D1\u05D7\u05E8\u05EA."]
  });
};

/* harmony default export */ var GiftCardScheduler_GiftCardStaticText = (GiftCardStaticText);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/PurchasePage/GiftCardScheduler/GiftCardSummaryText.tsx






var GiftCardSummaryText_StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "GiftCardSummaryText__StyledBox",
  componentId: "sc-1cdri7e-0"
})([""]);
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "GiftCardSummaryText__StyledText",
  componentId: "sc-1cdri7e-1"
})(["line-height:26px;text-align:right;span{font-weight:bold;font-family:NarkisBlock;}", "{width:680px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});

var GiftCardSummaryText = function GiftCardSummaryText(_ref) {
  var price = _ref.price,
      amount = _ref.amount,
      startDateTime = _ref.startDateTime,
      endDateTime = _ref.endDateTime,
      chargeAmount = _ref.chargeAmount;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardSummaryText_StyledBox, {
    children: amount > 1 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledText, {
      children: ["\u05D1\u05D7\u05E8\u05EA \u05DC\u05E9\u05DC\u05D5\u05D7 ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: amount
      }), " \u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3\u05D9\u05DD \u05E2\u05DC \u05E1\u05DA", " ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: [price.toString().replace(/[₪]/g, ""), " ", "\u05E9\"\u05D7"]
      }), " ", "\u05DC\u05DB\u05DC \u05D0\u05D7\u05D3. \u05D4\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3\u05D9\u05DD \u05D4\u05E8\u05D0\u05E9\u05D5\u05E0\u05D9\u05DD \u05D9\u05D7\u05D5\u05D9\u05D9\u05D1\u05D5 \u05D4\u05D9\u05D5\u05DD \u05D5\u05D9\u05D9\u05E9\u05DC\u05D7\u05D5 \u05D1-", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: moment_default()(startDateTime).format("DD.MM.YYYY")
      }), " \u05D5\u05DC\u05D0\u05D7\u05E8 \u05DE\u05DB\u05DF \u05E0\u05D7\u05D9\u05D9\u05D1 \u05E2\u05D5\u05D3 ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: chargeAmount - 1
      }), " \u05E4\u05E2\u05DE\u05D9\u05DD \u05E2\u05D3 \u05DC\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05D0\u05D7\u05E8\u05D5\u05DF \u05E9\u05E7\u05D1\u05E2\u05EA \u05D1- ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: moment_default()(endDateTime).format("DD.MM.YYYY")
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledText, {
      children: ["\u05D1\u05D7\u05E8\u05EA \u05DC\u05E9\u05DC\u05DD \u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05E2\u05DC \u05E1\u05DA", " ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: [price.toString().replace(/[₪]/g, ""), " ", "\u05E9\"\u05D7"]
      }), ". \u05D4\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D4\u05E8\u05D0\u05E9\u05D5\u05DF \u05D9\u05D7\u05D5\u05D9\u05D9\u05D1 \u05D4\u05D9\u05D5\u05DD \u05D5\u05D9\u05D9\u05E9\u05DC\u05D7 \u05D1-", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: moment_default()(startDateTime).format("DD.MM.YYYY")
      }), " \u05D5\u05DC\u05D0\u05D7\u05E8 \u05DE\u05DB\u05DF \u05E0\u05D7\u05D9\u05D9\u05D1 \u05E2\u05D5\u05D3 ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: chargeAmount - 1
      }), " \u05E4\u05E2\u05DE\u05D9\u05DD \u05E2\u05D3 \u05DC\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05D0\u05D7\u05E8\u05D5\u05DF \u05E9\u05E7\u05D1\u05E2\u05EA \u05D1- ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: moment_default()(endDateTime).format("DD.MM.YYYY")
      })]
    })
  });
};

/* harmony default export */ var GiftCardScheduler_GiftCardSummaryText = (GiftCardSummaryText);
// EXTERNAL MODULE: ./components/PurchasePage/LegalCheckboxes.tsx + 3 modules
var LegalCheckboxes = __webpack_require__(40839);
// EXTERNAL MODULE: ./components/GenericInput/GenericInput.tsx
var GenericInput = __webpack_require__(9108);
;// CONCATENATED MODULE: ./components/PurchasePage/MyPersonalFields.tsx










var MyPersonalFields_StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "MyPersonalFields__StyledBox",
  componentId: "sc-1yi1qud-0"
})(["margin-top:30px;.MuiFormHelperText-root{}", "{margin-top:60px;h4{margin-right:", ";}}"], function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.$selectedMode === "full" ? "150px" : "0px";
});
var StyledFieldWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "MyPersonalFields__StyledFieldWrapper",
  componentId: "sc-1yi1qud-1"
})(["", "{display:flex;flex-wrap:wrap;width:450px;gap:20px 0;justify-content:\"flex-start\";.MuiFormControl-root{width:200px !important;margin-left:10px;:nth-child(2n){margin-left:0;}}margin-right:", ";}"], function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.$selectedMode === "full" ? "150px" : "0px";
});
var MyPersonalFields_StyledError = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "MyPersonalFields__StyledError",
  componentId: "sc-1yi1qud-2"
})(["margin:0;padding:0;text-align:right;color:#d70202;font-size:20px;width:100%;line-height:1;margin-top:5px;", "{max-width:200px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledFormInput = (0,styled_components_browser_esm/* default */.ZP)(GenericInput/* GenericInput */.j).withConfig({
  displayName: "MyPersonalFields__StyledFormInput",
  componentId: "sc-1yi1qud-3"
})(["input{unicode-bidi:", ";text-align:right;}margin-top:10px;"], function (p) {
  return p.$unicodeBidi;
});
var StyledPersonalFormInput = (0,styled_components_browser_esm/* default */.ZP)(GenericInput/* GenericInput */.j).withConfig({
  displayName: "MyPersonalFields__StyledPersonalFormInput",
  componentId: "sc-1yi1qud-4"
})(["margin-top:10px;"]);
var StyledInputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyPersonalFields__StyledInputWrapper",
  componentId: "sc-1yi1qud-5"
})(["", "{> *{width:100%;}}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var MyPersonalFields = function MyPersonalFields(_ref) {
  var selectedMode = _ref.selectedMode,
      formatPhoneNumber = _ref.formatPhoneNumber;

  var _useFormikContext = (0,formik_esm.useFormikContext)(),
      setFieldValue = _useFormikContext.setFieldValue,
      values = _useFormikContext.values;

  var _usePurchaseContext = (0,PurchaseContext/* usePurchaseContext */.AX)(),
      blessingMode = _usePurchaseContext.blessingMode;

  var handlePhoneInput = function handlePhoneInput(evt, valueName) {
    //only allow numbers without '-' symbol
    if (evt.target.value.length) {
      var formattedValue = formatPhoneNumber(evt.target.value);
      setTimeout(function () {
        setFieldValue(valueName, formattedValue);
      }, 0);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MyPersonalFields_StyledBox, {
    $selectedMode: selectedMode,
    tabIndex: 0,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeadingText/* default */.Z, {
      text: "\u05D4\u05E4\u05E8\u05D8\u05D9\u05DD \u05E9\u05DC\u05D9",
      tabIndex: 0,
      textIndent: blessingMode !== "short",
      marginBottom: 20
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledFieldWrapper, {
      $selectedMode: selectedMode,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledInputWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledPersonalFormInput, {
          name: "senderName",
          label: "\u05E9\u05DD \u05E4\u05E8\u05D8\u05D9 (*\u05D7\u05D5\u05D1\u05D4)",
          type: "text",
          maxLength: 30,
          $width: "200px",
          $mobileWidth: "100%",
          autoComplete: "given-name",
          topMargin: "0"
        }), values.senderName.length > 30 && /*#__PURE__*/(0,jsx_runtime.jsx)(MyPersonalFields_StyledError, {
          children: "\u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D6\u05D9\u05DF \u05E2\u05D3 30 \u05EA\u05D5\u05D5\u05D9\u05DD"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledInputWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledPersonalFormInput, {
          name: "senderLastName",
          label: "\u05E9\u05DD \u05DE\u05E9\u05E4\u05D7\u05D4 (*\u05D7\u05D5\u05D1\u05D4)",
          type: "text",
          maxLength: 30,
          $width: "200px",
          $mobileWidth: "100%",
          autoComplete: "family-name",
          topMargin: "0"
        }), values.senderLastName.length > 30 && /*#__PURE__*/(0,jsx_runtime.jsx)(MyPersonalFields_StyledError, {
          children: "\u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D6\u05D9\u05DF \u05E2\u05D3 30 \u05EA\u05D5\u05D5\u05D9\u05DD"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledInputWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPersonalFormInput, {
          name: "senderMobilePhone",
          label: "(\u05D7\u05D5\u05D1\u05D4*) \u05D8\u05DC\u05E4\u05D5\u05DF",
          type: "tel",
          $width: "200px",
          $mobileWidth: "100%",
          numeric: true,
          onInput: function onInput(e) {
            return handlePhoneInput(e, "senderMobilePhone");
          },
          onPaste: /*#__PURE__*/function () {
            var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(e) {
              var clipboardData;
              return regenerator_default().wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      clipboardData = e.clipboardData.getData("Text");
                      e.clipboardData.clearData();
                      setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                        var phone;
                        return regenerator_default().wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                phone = formatPhoneNumber(clipboardData);
                                setFieldValue("senderMobilePhone", phone);

                              case 2:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee);
                      })), 300);

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }(),
          autoComplete: "tel",
          topMargin: "0"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledInputWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormInput, {
          name: "senderEmail",
          label: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC (*\u05D7\u05D5\u05D1\u05D4)",
          type: "text",
          $width: "200px",
          $mobileWidth: "100%",
          autoComplete: "email",
          inputMode: "email",
          $unicodeBidi: values.senderEmail.match(/[a-zA-Z]/) ? "plaintext" : "normal",
          topMargin: "0"
        })
      })]
    })]
  });
};

/* harmony default export */ var PurchasePage_MyPersonalFields = (MyPersonalFields);
// EXTERNAL MODULE: ./components/Reusable/Bit/NextLink.tsx
var NextLink = __webpack_require__(16110);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/PurchasePage/OtherPersonFields.tsx















var RecorderPage = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2663), __webpack_require__.e(8921), __webpack_require__.e(8685), __webpack_require__.e(2138)]).then(__webpack_require__.bind(__webpack_require__, 32138));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(32138)];
    }
  }
});
var VideoPage = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2004), __webpack_require__.e(8839)]).then(__webpack_require__.bind(__webpack_require__, 58839));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(58839)];
    }
  }
});
var OtherPersonFields_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OtherPersonFields__StyledWrapper",
  componentId: "sc-1w4dep8-0"
})(["position:relative;margin-top:20px;.MuiOutlinedInput-root{width:620px !important;height:120px !important;", "{width:100% !important;}}.MuiFormHelperText-root{display:none;}fieldset{height:120px;top:0px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledTextBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "OtherPersonFields__StyledTextBox",
  componentId: "sc-1w4dep8-1"
})(["display:flex;flex-direction:row;justify-content:space-between;", "{width:620px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "OtherPersonFields__StyledTypography",
  componentId: "sc-1w4dep8-2"
})(["margin-top:7px;"]);
var OtherPersonFields_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "OtherPersonFields__StyledText",
  componentId: "sc-1w4dep8-3"
})(["margin-top:7px;font-family:\"NarkisBlock\",sans-serif;font-weight:500;a{text-decoration:none;margin-left:5px;text-decoration:underline;}"]);
var OtherPersonFields_StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "OtherPersonFields__StyledBox",
  componentId: "sc-1w4dep8-4"
})(["margin-top:60px;.MuiOutlinedInput-root{", "{height:40px;width:200px;}.MuiInputBase-inputMultiline{height:100% !important;font-size:20px;color:#000;font-family:Speedee,NarkisBlock,sans-serif;font-weight:500;}}", "{margin-top:30px;}"], function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var OtherPersonFields_StyledFieldWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "OtherPersonFields__StyledFieldWrapper",
  componentId: "sc-1w4dep8-5"
})(["", "{display:flex;.MuiFormControl-root{margin-left:10px;}> *{width:200px;}}", "{.MuiFormHelperText-contained{display:none;}.MuiFormHelperText-contained.Mui-error{display:block;}}"], function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledFieldBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "OtherPersonFields__StyledFieldBox",
  componentId: "sc-1w4dep8-6"
})(["margin-left:10px;", "{> *{width:100%;}}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledtextWrapp = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "OtherPersonFields__StyledtextWrapp",
  componentId: "sc-1w4dep8-7"
})(["display:flex;justify-content:space-between;"]);
var StyledContactTextWrapp = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "OtherPersonFields__StyledContactTextWrapp",
  componentId: "sc-1w4dep8-8"
})(["display:flex;flex-direction:column;align-items:flex-end;margin-left:10px;"]);
var StyledContactText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "OtherPersonFields__StyledContactText",
  componentId: "sc-1w4dep8-9"
})(["color:#264f36;font-family:\"NarkisBlock\";cursor:pointer;text-decoration:underline;"]);
var StyledContactError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "OtherPersonFields__StyledContactError",
  componentId: "sc-1w4dep8-10"
})(["font-size:18px;color:#d70202;line-height:110%;"]);
var MediaButtons = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "OtherPersonFields__MediaButtons",
  componentId: "sc-1w4dep8-11"
})(["display:flex;justify-content:", ";", "{flex-direction:column;}", "{width:620px;}"], function (p) {
  return p.$justify && p.$justify;
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledGenericInput = (0,styled_components_browser_esm/* default */.ZP)(GenericInput/* GenericInput */.j).withConfig({
  displayName: "OtherPersonFields__StyledGenericInput",
  componentId: "sc-1w4dep8-12"
})([""]);

var OtherPersonFields = function OtherPersonFields(_ref) {
  var _values$recipientEmai, _values$senderBlessin, _values$senderBlessin2;

  var formatPhoneNumber = _ref.formatPhoneNumber,
      saveGiftCardData = _ref.saveGiftCardData;

  var _useFormikContext = (0,formik_esm.useFormikContext)(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;

  var _useState = (0,react.useState)(null),
      contactError = _useState[0],
      setContactErrors = _useState[1];

  var _useState2 = (0,react.useState)(null),
      contacts = _useState2[0],
      setContacts = _useState2[1];

  var _usePurchaseContext = (0,PurchaseContext/* usePurchaseContext */.AX)(),
      purchaseData = _usePurchaseContext.purchaseData,
      setIsVideoApproved = _usePurchaseContext.setIsVideoApproved,
      isVideoApproved = _usePurchaseContext.isVideoApproved;

  var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
  var emailRef = (0,react.useRef)(null);

  var _useState3 = (0,react.useState)(false),
      isAndroidChrome = _useState3[0],
      setIsAndroidChrome = _useState3[1];

  var handlePhoneInput = function handlePhoneInput(evt, valueName) {
    //only allow numbers without '-' symbol
    if (evt.target.value.length) {
      var formattedValue = formatPhoneNumber(evt.target.value);
      setTimeout(function () {
        console.log({
          formattedValue: formattedValue
        });
        setFieldValue(valueName, formattedValue);
      }, 0);
    }
  };

  var updateFormikValues = function updateFormikValues(field, value) {
    return setFieldValue(field, value);
  };

  var getContact = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var supported, opts, props, _contacts;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              supported = "contacts" in navigator && "ContactsManager" in window;

              if (!supported) {
                _context.next = 16;
                break;
              }

              opts = {
                multiple: false
              };
              props = ["name", "email", "tel"];
              _context.prev = 4;
              _context.next = 7;
              return navigator.contacts.select(props, opts);

            case 7:
              _contacts = _context.sent;
              setContacts(_contacts);
              setContactErrors(null);
              _contacts && _contacts.forEach(function (contact) {
                if (contact.name) {
                  updateFormikValues("recipientName", contact.name.toString());
                } else {
                  updateFormikValues("recipientName", "");
                }

                if (contact.email) {
                  var _contact$email$toStri;

                  updateFormikValues("recipientEmail", (_contact$email$toStri = contact.email.toString()) === null || _contact$email$toStri === void 0 ? void 0 : _contact$email$toStri.trim());
                } else {
                  updateFormikValues("recipientEmail", "");
                }

                if (contact.tel) {
                  if (contact.tel.length > 1) {
                    updateFormikValues("phoneNumber", formatPhoneNumber(contact.tel[0].toString()));
                  } else {
                    updateFormikValues("phoneNumber", formatPhoneNumber(contact.tel.toString()));
                  }
                } else {
                  updateFormikValues("phoneNumber", formatPhoneNumber(""));
                }
              });
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](4);
              setContactErrors("אופס לא הצליח, שננסה שוב?");

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 13]]);
    }));

    return function getContact() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handlePaste = function handlePaste() {
    setTimeout(function () {
      emailRef.current.childNodes[1].firstChild.blur();
      emailRef.current.childNodes[1].firstChild.focus();
    }, 300);
  };

  (0,react.useEffect)(function () {
    var isChromeOnAndroid = /Chrome/i.test(navigator.userAgent) && /Android/i.test(navigator.userAgent);
    setIsAndroidChrome(isChromeOnAndroid);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OtherPersonFields_StyledBox, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledtextWrapp, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeadingText/* default */.Z, {
        text: "\u05DC\u05DE\u05D9 \u05D4\u05DE\u05EA\u05E0\u05D4?",
        tabIndex: 0,
        marginBottom: !isDesktop ? 0 : 30
      }), isAndroidChrome && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContactTextWrapp, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledContactText, {
          onClick: getContact,
          children: contacts ? "הוספת איש קשר אחר" : "הוספת איש/אשת קשר"
        }), contactError && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledContactError, {
          children: "\u05D0\u05D5\u05E4\u05E1 \u05DC\u05D0 \u05D4\u05E6\u05DC\u05D9\u05D7, \u05E9\u05E0\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1?"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OtherPersonFields_StyledFieldWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledFieldBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
          name: "recipientName",
          label: "\u05E9\u05DD/\u05E9\u05DD \u05D7\u05D9\u05D1\u05D4 (*\u05D7\u05D5\u05D1\u05D4)",
          type: "text",
          maxLength: 30,
          $width: "200px",
          autoComplete: "name",
          id: "otherPersonRecipientName",
          topMargin: isDesktop ? "0" : "20"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFieldBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
          name: "phoneNumber",
          label: "\u05D8\u05DC\u05E4\u05D5\u05DF (*\u05D7\u05D5\u05D1\u05D4)",
          $width: "200px",
          type: "tel",
          numeric: true,
          onInput: function onInput(e) {
            return handlePhoneInput(e, "phoneNumber");
          },
          onPaste: /*#__PURE__*/function () {
            var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(e) {
              var clipboardData;
              return regenerator_default().wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      clipboardData = e.clipboardData.getData("Text");
                      setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
                        var phone;
                        return regenerator_default().wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                phone = formatPhoneNumber(clipboardData.toString());
                                setFieldValue("phoneNumber", phone);

                              case 2:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2);
                      })), 300);

                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }));

            return function (_x) {
              return _ref3.apply(this, arguments);
            };
          }(),
          autoComplete: "tel",
          topMargin: isDesktop && "0"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFieldBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledGenericInput, {
          name: "recipientEmail",
          label: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
          type: "text",
          $width: "200px",
          autoComplete: "email",
          innerRef: emailRef,
          inputMode: "email",
          $unicodeBidi: values !== null && values !== void 0 && (_values$recipientEmai = values.recipientEmail) !== null && _values$recipientEmai !== void 0 && _values$recipientEmai.match(/[a-zA-Z]/) ? "plaintext" : "normal",
          topMargin: isDesktop && "0",
          onPaste: handlePaste
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OtherPersonFields_StyledWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledFieldBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
          name: "senderBlessing",
          label: "\u05DB\u05EA\u05D9\u05D1\u05EA \u05D1\u05E8\u05DB\u05D4",
          type: "text",
          InputProps: {
            multiline: true
          },
          maxLength: 100,
          topMargin: isDesktop && "0"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTextBox, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTypography, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            fontWeight: (values === null || values === void 0 ? void 0 : (_values$senderBlessin = values.senderBlessing) === null || _values$senderBlessin === void 0 ? void 0 : _values$senderBlessin.length) > 0 ? "bold" : "normal",
            children: (values === null || values === void 0 ? void 0 : (_values$senderBlessin2 = values.senderBlessing) === null || _values$senderBlessin2 === void 0 ? void 0 : _values$senderBlessin2.length) || 0
          }), "/100"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OtherPersonFields_StyledText, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NextLink/* default */.Z, {
            href: "/ethics",
            onClick: function onClick() {
              return saveGiftCardData(values);
            },
            children: "\u05D4\u05E7\u05D5\u05D3 \u05D4\u05D0\u05EA\u05D9 \u05E9\u05DC\u05E0\u05D5"
          }), "\u05DC\u05DB\u05EA\u05D9\u05D1\u05EA \u05D1\u05E8\u05DB\u05D4"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MediaButtons, {
        $justify: (isVideoApproved || (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.audioBlessingBase64)) && "space-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RecorderPage, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(VideoPage, {
          setIsApproved: setIsVideoApproved,
          isApproved: isVideoApproved
        })]
      })]
    })]
  });
};

/* harmony default export */ var PurchasePage_OtherPersonFields = (OtherPersonFields);
;// CONCATENATED MODULE: ./components/PurchasePage/PurchaseButton.tsx





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var PurchaseButton_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "PurchaseButton__StyledButton",
  componentId: "sc-1qdxol9-0"
})(["width:150px;height:40px;margin-top:12px;background-color:", ";color:", ";display:flex;justify-content:center;align-items:center;font-family:NarkisBlock;font-size:20px;font-weight:bold;", "{width:100%;height:48px;margin-left:10px;font-size:24px;}:hover{border:1px solid ", ";}"], function (p) {
  return p.$isSelected ? colors/* default.darkGreen */.Z.darkGreen : colors/* default.grey */.Z.grey;
}, function (p) {
  return p.$isSelected ? colors/* default.white */.Z.white : colors/* default.warmGray */.Z.warmGray;
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, colors/* default.darkGreen */.Z.darkGreen);
var PurchaseButton_StyledLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "PurchaseButton__StyledLabel",
  componentId: "sc-1qdxol9-1"
})(["cursor:pointer;width:100%;height:100%;:focus{outline:none;}"]);
var StyledButoonWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "PurchaseButton__StyledButoonWrapper",
  componentId: "sc-1qdxol9-2"
})(["button{", "{width:50%;}}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var PurchaseButton = function PurchaseButton(_ref) {
  var handleSelectMode = _ref.handleSelectMode,
      blessingType = _ref.blessingType,
      formik = _ref.formik,
      blessingMode = _ref.blessingMode;
  var buttons = blessingType === "Myself" ? [{
    value: 0,
    text: "לעצמי",
    type: "short"
  }] : blessingType === "Another" ? [{
    value: 0,
    text: "למישהי / מישהו",
    type: "full"
  }] : [{
    value: 0,
    text: "למישהי / מישהו",
    type: "full"
  }, {
    value: 1,
    text: "לעצמי",
    type: "short"
  }];

  var handleButtonClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(code) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handleSelectMode(buttons[code].type);
              _context.next = 3;
              return formik.validateForm();

            case 3:
              formik.setTouched(_objectSpread({}, formik.touched));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleButtonClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButoonWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SingleButtonSelection/* default */.Z, {
      id: "routesSelect",
      items: buttons.map(function (amount) {
        return {
          value: amount.value,
          name: amount.text
        };
      }),
      onSelect: function onSelect(code) {
        return handleButtonClick(code);
      },
      gap: 15,
      selectedValue: blessingMode && blessingMode === "short" ? 1 : 0,
      itemsPerRow: "auto",
      customButton: function customButton(radioId, isSelected, item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PurchaseButton_StyledLabel, {
            htmlFor: radioId,
            $activeButton: isSelected,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(PurchaseButton_StyledButton, {
              $isSelected: isSelected,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: item.name
              })
            })
          })
        });
      }
    })
  });
};

/* harmony default export */ var PurchasePage_PurchaseButton = (PurchaseButton);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
;// CONCATENATED MODULE: ./components/PurchasePage/QuantityBox.tsx








var QuantityBox_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "QuantityBox__StyledButton",
  componentId: "sc-i6g580-0"
})(["width:50px;height:50px;color:#757575;min-width:50px;font-size:26px;font-family:\"NarkisBlock-Thin\",san-serif;font-weight:100;border-radius:8px;border:1px solid #e5e5e5;background:var(--White,#fff);:hover{background:var(--White,#fff);border:2px solid var(--Grey,#757575);}"]);
var StyledBoxWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "QuantityBox__StyledBoxWrapper",
  componentId: "sc-i6g580-1"
})(["display:flex;flex-direction:column;margin-top:4px;"]);
var StyledValueBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "QuantityBox__StyledValueBox",
  componentId: "sc-i6g580-2"
})(["width:50px;height:50px;color:#757575;display:flex;align-items:center;justify-content:center;margin-left:5px;margin-right:5px;input{font-family:", ";font-weight:", ";font-size:26px;text-align:center;padding-left:0px;padding-right:0px;background:var(--White,#fff);&:disabled{color:", ";-webkit-text-fill-color:", ";}}.MuiOutlinedInput-input{color:", ";}fieldset{border:none;border-radius:8px;border:1px #e5e5e5 solid;}div{margin-top:0px;}.MuiFormControl-root{width:50px;height:50px;}#quantity-helper-text{width:300px;margin-right:-55px !important;}.MuiOutlinedInput-root{box-shadow:none;}fieldset{width:50px;height:50px;top:0;}"], function (p) {
  return p.$quantity > 0 ? "NarkisBlock" : "inherit";
}, function (p) {
  return p.$quantity > 0 ? "bold" : "normal";
}, function (p) {
  return p.$quantity > 0 ? "#264f36 !important" : "#757575";
}, function (p) {
  return p.$quantity > 0 ? "#264f36" : "#757575";
}, function (p) {
  return p.$quantity > 0 ? "#264f36 !important" : "#757575";
});
var QuantityBox_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "QuantityBox__StyledWrapper",
  componentId: "sc-i6g580-3"
})(["height:76px;", "{margin-bottom:0px;}p{color:#000;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var QuantityBox_StyledError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "QuantityBox__StyledError",
  componentId: "sc-i6g580-4"
})(["color:#d70202 !important;line-height:1.1;text-align:right;margin-top:4px;"]);
var QuantityBox_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "QuantityBox__StyledText",
  componentId: "sc-i6g580-5"
})(["font-size:18px;text-align:right;"]);

var QuantityBox = function QuantityBox(_ref) {
  var quantityError = _ref.quantityError,
      setQuantityError = _ref.setQuantityError,
      setAmountError = _ref.setAmountError,
      quantity = _ref.quantity,
      setQuantity = _ref.setQuantity,
      maxGiftCard = _ref.maxGiftCard,
      maxAmuont = _ref.maxAmuont,
      minAmount = _ref.minAmount;
  var formikProps = (0,formik_esm.useFormikContext)();

  var checkAmountValidation = function checkAmountValidation(number) {
    if (number * formikProps.values.amount > maxAmuont) setAmountError("\u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05DB\u05E0\u05D9\u05E1 \u05E1\u05DB\u05D5\u05DD \u05DE\u05E7\u05E1\u05D9\u05DE\u05DC\u05D9 \u05E9\u05DC \u05E2\u05D3 ".concat(maxAmuont, " \u05E9\u05F4\u05D7"));else if (number * formikProps.values.amount < minAmount) setAmountError("\u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05DB\u05E0\u05D9\u05E1 \u05E1\u05DB\u05D5\u05DD \u05DE\u05D9\u05E0\u05D9\u05DE\u05DC\u05D9 \u05E9\u05DC \u05DC\u05E4\u05D7\u05D5\u05EA ".concat(minAmount, " \u05E9\u05F4\u05D7"));else setAmountError("");
  };

  var incrementCounter = function incrementCounter() {
    if (quantity < maxGiftCard) {
      setQuantity(quantity + 1);
      formikProps.setFieldValue("quantity", quantity + 1);
      checkAmountValidation(quantity + 1);
    } else setQuantityError(true);
  };

  var decrementCounter = function decrementCounter() {
    if (quantity > 1) {
      checkAmountValidation(quantity - 1);
      setQuantity(quantity - 1);
      formikProps.setFieldValue("quantity", quantity - 1);
    }

    if (quantityError) setQuantityError(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(QuantityBox_StyledWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(QuantityBox_StyledText, {
      children: "\u05DB\u05DE\u05D5\u05EA \u05DB\u05E8\u05D8\u05D9\u05E1\u05D9 \u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledBoxWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(QuantityBox_StyledButton, {
          onClick: incrementCounter,
          "aria-label": "\u05D4\u05D5\u05E1\u05E4\u05EA \u05D9\u05D7\u05D9\u05D3\u05D4 \u05D1\u05E8\u05DB\u05D9\u05E9\u05EA \u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3",
          children: "+"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledValueBox, {
          $quantity: quantity,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
            name: "quantity",
            label: "",
            type: "text",
            disabled: true,
            value: quantity
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuantityBox_StyledButton, {
          onClick: decrementCounter,
          "aria-label": "\u05D4\u05E1\u05E8\u05EA \u05D9\u05D7\u05D9\u05D3\u05D4 \u05DE\u05D4\u05D6\u05DE\u05E0\u05EA \u05D4\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3",
          children: "-"
        })]
      }), quantityError && /*#__PURE__*/(0,jsx_runtime.jsxs)(QuantityBox_StyledError, {
        children: ["\u05E0\u05D9\u05EA\u05DF \u05DC\u05E8\u05DB\u05D5\u05E9 \u05E2\u05D3 ", maxGiftCard, " \u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3\u05D9\u05DD"]
      })]
    })]
  });
};

/* harmony default export */ var PurchasePage_QuantityBox = (QuantityBox);
// EXTERNAL MODULE: ./components/Reusable/Bit/FormikSchema.ts
var FormikSchema = __webpack_require__(39163);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/PurchasePage/SchemaPurchase.tsx


var schemaPurchaseFull = es/* object */.Ry({
  amount: FormikSchema/* schemaCommon.amount */.Cr.amount,
  senderName: FormikSchema/* schemaCommon.firstName */.Cr.firstName,
  senderLastName: FormikSchema/* schemaCommon.lastName */.Cr.lastName,
  recipientEmail: FormikSchema/* schemaCommon.recipientEmail */.Cr.recipientEmail,
  phoneNumber: FormikSchema/* schemaCommon.phoneNumber */.Cr.phoneNumber,
  recipientName: FormikSchema/* schemaCommon.fullName */.Cr.fullName,
  senderMobilePhone: FormikSchema/* schemaCommon.phoneNumber */.Cr.phoneNumber,
  senderEmail: FormikSchema/* schemaCommon.email */.Cr.email,
  checkedOne: FormikSchema/* schemaCommon.checkbox */.Cr.checkbox,
  quantity: FormikSchema/* schemaCommon.qauntity */.Cr.qauntity
}).defined();
var schemaPurchaseShort = es/* object */.Ry({
  amount: FormikSchema/* schemaCommon.amount */.Cr.amount,
  senderName: FormikSchema/* schemaCommon.firstName */.Cr.firstName,
  senderLastName: FormikSchema/* schemaCommon.lastName */.Cr.lastName,
  senderMobilePhone: FormikSchema/* schemaCommon.phoneNumber */.Cr.phoneNumber,
  senderEmail: FormikSchema/* schemaCommon.email */.Cr.email,
  checkedOne: FormikSchema/* schemaCommon.checkbox */.Cr.checkbox,
  quantity: FormikSchema/* schemaCommon.qauntity */.Cr.qauntity
}).defined();
/* harmony default export */ var SchemaPurchase = ({
  schemaPurchaseFull: schemaPurchaseFull,
  schemaPurchaseShort: schemaPurchaseShort
});
;// CONCATENATED MODULE: ./components/PurchasePage/PurchaseProcess.tsx






function PurchaseProcess_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PurchaseProcess_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PurchaseProcess_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PurchaseProcess_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }































var PurchaseProcess_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "PurchaseProcess__StyledWrapper",
  componentId: "sc-1kp8b80-0"
})(["padding:94px 16px 80px 16px;", "{display:flex;padding:120px 60px 80px 60px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledBackButton = (0,styled_components_browser_esm/* default */.ZP)(BackButton/* default */.Z).withConfig({
  displayName: "PurchaseProcess__StyledBackButton",
  componentId: "sc-1kp8b80-1"
})(["", "{margin-bottom:48px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  component: "h1",
  variant: "h2"
}).withConfig({
  displayName: "PurchaseProcess__StyledTitle",
  componentId: "sc-1kp8b80-2"
})(["color:#000;text-align:right;margin-top:20px;margin-bottom:20px;line-height:0.8;", "{font-size:40px;width:500px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var PurchaseProcess_StyledError = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "PurchaseProcess__StyledError",
  componentId: "sc-1kp8b80-3"
})(["color:#d70202;font-size:20px;text-align:right;line-height:1.1;"]);
var StyledButtonBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "PurchaseProcess__StyledButtonBox",
  componentId: "sc-1kp8b80-4"
})(["display:flex;", "{padding-bottom:20px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var PurchaseProcess_StyledFieldWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "PurchaseProcess__StyledFieldWrapper",
  componentId: "sc-1kp8b80-5"
})(["", "{display:flex;justify-content:flex-start;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledCardWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "PurchaseProcess__StyledCardWrapper",
  componentId: "sc-1kp8b80-6"
})(["", "{display:flex;justify-content:flex-start;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledBoxWrap = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "PurchaseProcess__StyledBoxWrap",
  componentId: "sc-1kp8b80-7"
})(["", "{width:760px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledScheduleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PurchaseProcess__StyledScheduleWrapper",
  componentId: "sc-1kp8b80-8"
})(["position:relative;"]);
var StyledScheduleError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PurchaseProcess__StyledScheduleError",
  componentId: "sc-1kp8b80-9"
})(["color:#d70202;font-size:18px;line-height:1;text-align:right;position:absolute;bottom:-20px;"]);

var PurchaseProcess = function PurchaseProcess(_ref) {
  var _purchaseData$recipie, _purchaseData$senderE, _purchaseData$senderE2;

  var giftCard = _ref.giftCard,
      setting = _ref.setting,
      setRefList = _ref.setRefList;

  var _usePurchaseContext = (0,PurchaseContext/* usePurchaseContext */.AX)(),
      purchaseData = _usePurchaseContext.purchaseData,
      setPurchaseData = _usePurchaseContext.setPurchaseData,
      setBlessingMode = _usePurchaseContext.setBlessingMode,
      setSelectedGiftCard = _usePurchaseContext.setSelectedGiftCard,
      categoryName = _usePurchaseContext.categoryName,
      prevPath = _usePurchaseContext.prevPath,
      blessingMode = _usePurchaseContext.blessingMode,
      setSchedulerType = _usePurchaseContext.setSchedulerType,
      schedulerType = _usePurchaseContext.schedulerType;

  var router = (0,next_router.useRouter)();
  var Section1Ref = (0,react.useRef)(null);
  var amountRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    setRefList([Section1Ref]);
  }, []);
  var blessingType = giftCard === null || giftCard === void 0 ? void 0 : giftCard.blessingType;

  var _useState = (0,react.useState)(blessingMode.length ? blessingMode : blessingType === "Both" || blessingType === "Another" ? "full" : "short"),
      selectedMode = _useState[0],
      setSelectedMode = _useState[1];

  var _useState2 = (0,react.useState)(false),
      quantityError = _useState2[0],
      setQuantityError = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      amountError = _useState3[0],
      setAmountError = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      noValueValidation = _useState4[0],
      setNoValueValidation = _useState4[1];

  var _useState5 = (0,react.useState)((purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.quantity) || 0),
      quantity = _useState5[0],
      setQuantity = _useState5[1];

  var _useState6 = (0,react.useState)(schedulerType ? schedulerType : giftCard !== null && giftCard !== void 0 && giftCard.blessingScheduleTypeDefault ? giftCard.blessingScheduleTypeDefault : '"AfterPayment"'),
      scheduleType = _useState6[0],
      setScheduleType = _useState6[1];

  var _useState7 = (0,react.useState)(purchaseData !== null && purchaseData !== void 0 && purchaseData.allowanceStartDateTime ? purchaseData.allowanceStartDateTime : null),
      scheduleStartTime = _useState7[0],
      setScheduleStartTime = _useState7[1];

  var _useState8 = (0,react.useState)(purchaseData !== null && purchaseData !== void 0 && purchaseData.allowanceEndDateTime ? purchaseData.allowanceEndDateTime : null),
      scheduleEndTime = _useState8[0],
      setScheduleEndTime = _useState8[1];

  var _useState9 = (0,react.useState)(purchaseData !== null && purchaseData !== void 0 && purchaseData.giftCardScheduleType ? purchaseData.giftCardScheduleType : null),
      frequency = _useState9[0],
      setFrequency = _useState9[1];

  var _useState10 = (0,react.useState)(0),
      chargeAmount = _useState10[0],
      setChargeAmount = _useState10[1];

  var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
  var regex = /^[a-zA-Zא-תء-ي'"‘’\\.\-,\s]+$/;

  var _useState11 = (0,react.useState)(purchaseData !== null && purchaseData !== void 0 && purchaseData.messagesScheduleDate ? purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.messagesScheduleDate : null),
      date = _useState11[0],
      setDate = _useState11[1];

  var _useState12 = (0,react.useState)(null),
      scheduleError = _useState12[0],
      setScheduleError = _useState12[1];

  var _useState13 = (0,react.useState)(null),
      scheduleTypeError = _useState13[0],
      setScheduleTypeError = _useState13[1];

  var _useState14 = (0,react.useState)(null),
      pastTimeError = _useState14[0],
      setPastTimeError = _useState14[1];

  (0,react.useEffect)(function () {
    if (!schedulerType) setSchedulerType(scheduleType);
  }, [scheduleType]);
  (0,react.useEffect)(function () {
    if (scheduleStartTime) {
      if (new Date(scheduleStartTime) > new Date()) {
        setPastTimeError(null);
      }
    }

    if (scheduleEndTime && scheduleStartTime) {
      var startTime = new Date(scheduleStartTime);
      var endTime = new Date(scheduleEndTime);
      endTime.setHours(startTime.getHours(), startTime.getMinutes());

      var getfrequency = /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
          var data, response;
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  data = {
                    startDateTime: scheduleStartTime,
                    endDateTime: endTime.toISOString(),
                    giftCardScheduleType: frequency
                  };
                  _context.next = 3;
                  return (0,api.postGiftCardGetGiftCardSchedule)(data);

                case 3:
                  response = _context.sent;
                  setChargeAmount(response.data.body.schedule.length);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function getfrequency() {
          return _ref2.apply(this, arguments);
        };
      }();

      getfrequency();
    }
  }, [scheduleEndTime, scheduleStartTime]);
  (0,react.useEffect)(function () {
    giftCard && (0,analytics/* productDetailView */.$1)(categoryName, giftCard.id, giftCard.name);
  }, [giftCard]);
  (0,react.useEffect)(function () {
    if (router.query && router.query.focus && document) {
      var _document;

      var input = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById(router.query.focus.toString());
      input === null || input === void 0 ? void 0 : input.scrollIntoView();
      setTimeout(function () {
        input === null || input === void 0 ? void 0 : input.focus();
      }, 1500);
    }
  }, [router]);
  var initialValues = blessingType === "Both" || blessingType === "Another" ? {
    amount: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.amount) || "",
    recipientName: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.recipientName) || "",
    phoneNumber: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.phoneNumber) || "",
    recipientEmail: (purchaseData === null || purchaseData === void 0 ? void 0 : (_purchaseData$recipie = purchaseData.recipientEmail) === null || _purchaseData$recipie === void 0 ? void 0 : _purchaseData$recipie.trim()) || "",
    senderBlessing: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.senderBlessing) || "",
    senderName: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.senderName) || "",
    senderLastName: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.senderLastName) || "",
    senderMobilePhone: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.senderMobilePhone) || "",
    senderEmail: (purchaseData === null || purchaseData === void 0 ? void 0 : (_purchaseData$senderE = purchaseData.senderEmail) === null || _purchaseData$senderE === void 0 ? void 0 : _purchaseData$senderE.trim()) || "",
    checkedOne: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData["checkedOne"]) || false,
    checkedTwo: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData["checkedTwo"]) || false,
    quantity: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.quantity) || 0
  } : {
    amount: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.amount) || "",
    senderName: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.senderName) || "",
    senderLastName: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.senderLastName) || "",
    senderMobilePhone: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.senderMobilePhone) || "",
    senderEmail: (purchaseData === null || purchaseData === void 0 ? void 0 : (_purchaseData$senderE2 = purchaseData.senderEmail) === null || _purchaseData$senderE2 === void 0 ? void 0 : _purchaseData$senderE2.trim()) || "",
    checkedOne: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData["checkedOne"]) || false,
    checkedTwo: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData["checkedTwo"]) || false,
    quantity: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.quantity) || 0
  };

  var handleSelectMode = function handleSelectMode(mode) {
    setSelectedMode(mode);
    setBlessingMode(mode);
  };

  var buttonValid = function buttonValid(valid, touched, amount) {
    return valid && (Object.keys(touched).length > 0 || purchaseData) && !amountError && quantity > 0 && amount > 0;
  };

  var saveGiftCardData = function saveGiftCardData(values) {
    if (scheduleType === "Allowance") {
      purchaseData.allowanceStartDateTime = scheduleStartTime;
      purchaseData.allowanceEndDateTime = scheduleEndTime;
      purchaseData.giftCardScheduleType = frequency;
    }

    if (scheduleType === "Scheduled" && date) {
      purchaseData.messagesScheduleDate = date; // clear the allowance fields

      delete purchaseData["allowanceStartDateTime"];
      delete purchaseData["allowanceEndDateTime"];
      delete purchaseData["giftCardScheduleType"];
    }

    setPurchaseData(PurchaseProcess_objectSpread(PurchaseProcess_objectSpread({}, purchaseData), values));
  };

  var validationSchema = (0,react.useMemo)(function () {
    return selectedMode === "full" ? SchemaPurchase.schemaPurchaseFull : SchemaPurchase.schemaPurchaseShort;
  }, [selectedMode]);

  var onSubmit = function onSubmit(values) {
    if (schedulerType === "Scheduled" && date) {
      values.messagesScheduleDate = date;
    } else {
      if (purchaseData !== null && purchaseData !== void 0 && purchaseData.messagesScheduleDate) {
        delete values["messagesScheduleDate"];
        delete purchaseData["messagesScheduleDate"];
      }
    }

    if (scheduleType === "Allowance") {
      var startTime = new Date(scheduleStartTime);
      var endTime = new Date(scheduleEndTime);
      endTime.setHours(startTime.getHours(), startTime.getMinutes());
      values.allowanceStartDateTime = scheduleStartTime;
      values.allowanceEndDateTime = endTime;
      values.giftCardScheduleType = frequency;
    } else if (purchaseData !== null && purchaseData !== void 0 && purchaseData.allowanceStartDateTime || purchaseData !== null && purchaseData !== void 0 && purchaseData.allowanceEndDateTime || purchaseData !== null && purchaseData !== void 0 && purchaseData.giftCardScheduleType) {
      delete values["allowanceStartDateTime"];
      delete values["allowanceEndDateTime"];
      delete values["giftCardScheduleType"];
      delete purchaseData["allowanceStartDateTime"];
      delete purchaseData["allowanceEndDateTime"];
      delete purchaseData["giftCardScheduleType"];
    }

    values.amount = parseInt(values.amount.toString().replace(/[₪]/g, ""));
    setPurchaseData(PurchaseProcess_objectSpread(PurchaseProcess_objectSpread({}, purchaseData), values));
    setBlessingMode(selectedMode);
    setSelectedGiftCard(giftCard);
    router.push("/preview");
  };

  var showOveralError = function showOveralError(touched) {
    var error = "*בבקשה לבדוק שהשלמת את כל הפרטים נכון";

    if (Object.keys(touched).length === 1 && Object.prototype.hasOwnProperty.call(touched, "senderBlessing")) {
      return "";
    } else {
      return error;
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PurchaseProcess_StyledWrapper, {
    children: [!isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(BackButton/* default */.Z, {
      linkText: "\u05D7\u05D6\u05E8\u05D4",
      prevPath: giftCard !== null && giftCard !== void 0 && giftCard.isAiImage ? "/create-ai/choose-picture" : prevPath
    }), !isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(PurchasePage_GiftCardInfo, {
      giftCard: giftCard
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
      validationSchema: validationSchema,
      initialValues: initialValues,
      onSubmit: /*#__PURE__*/function () {
        var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(values) {
          var amount;
          return regenerator_default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  amount = parseInt(values.amount.toString().replace(/[₪]/g, ""));

                  if (!amountError && amount > 0 && values.quantity > 0) {
                    onSubmit(values);
                  }

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }(),
      alwaysValidate: true,
      render: function render(formik) {
        var _giftCard$promotion;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCardWrapper, {
            children: [isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(PurchasePage_GiftCardInfo, {
              giftCard: giftCard
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledBoxWrap, {
              children: [isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledBackButton, {
                linkText: "\u05D7\u05D6\u05E8\u05D4",
                prevPath: giftCard !== null && giftCard !== void 0 && giftCard.isAiImage ? "/create-ai/choose-picture" : prevPath
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTitle, {
                ref: Section1Ref,
                children: ["\u05D4\u05D6\u05E0\u05EA \u05E4\u05E8\u05D8\u05D9\u05DD \u05DC\u05E8\u05DB\u05D9\u05E9\u05EA \u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05DE\u05E1\u05D5\u05D2 - ", giftCard === null || giftCard === void 0 ? void 0 : giftCard.name]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(PurchasePage_PurchaseButton, {
                blessingType: giftCard === null || giftCard === void 0 ? void 0 : giftCard.blessingType,
                handleSelectMode: handleSelectMode,
                formik: formik,
                blessingMode: blessingMode
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(GIftCardAmount, {
                setAmountError: setAmountError,
                amountError: amountError,
                setQuantity: setQuantity,
                amounts: (setting === null || setting === void 0 ? void 0 : setting.giftCardAmounts) || [],
                maxAmuont: (setting === null || setting === void 0 ? void 0 : setting.maxAmuont) || 1500,
                minAmount: (setting === null || setting === void 0 ? void 0 : setting.minamuont) || 1,
                amountRef: amountRef,
                setNoValueValidation: setNoValueValidation,
                noValueValidation: noValueValidation,
                validateForm: formik.validateForm,
                purchaseData: purchaseData,
                promotion: giftCard === null || giftCard === void 0 ? void 0 : (_giftCard$promotion = giftCard.promotion) === null || _giftCard$promotion === void 0 ? void 0 : _giftCard$promotion.name
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(PurchasePage_QuantityBox, {
                quantityError: quantityError,
                setQuantityError: setQuantityError,
                setAmountError: setAmountError,
                quantity: quantity,
                setQuantity: setQuantity,
                maxGiftCard: (setting === null || setting === void 0 ? void 0 : setting.maxGiftCard) || 5,
                maxAmuont: (setting === null || setting === void 0 ? void 0 : setting.maxAmuont) || 1500,
                minAmount: (setting === null || setting === void 0 ? void 0 : setting.minamuont) || 1
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardScheduler/* default */.Z, {
            setScheduleType: setScheduleType,
            scheduleType: scheduleType,
            setSchedulerType: setSchedulerType
          }), scheduleType === "Allowance" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardScheduler_GiftCardStaticText, {
              amount: formik.values.amount ? formik.values.amount : 0,
              quantity: formik.values.quantity ? formik.values.quantity : 1
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardScheduler_GiftCardStartTime, {
              setScheduleStartTime: setScheduleStartTime,
              scheduleStartTime: scheduleStartTime,
              scheduleError: scheduleError,
              setScheduleEndTime: setScheduleEndTime,
              pastTimeError: pastTimeError
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardScheduler_GiftCardFrequency, {
              setFrequency: setFrequency,
              scheduleError: scheduleError,
              frequency: frequency,
              setScheduleEndTime: setScheduleEndTime
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardScheduler_GiftCardEndTime, {
              setScheduleEndTime: setScheduleEndTime,
              scheduleEndTime: scheduleEndTime,
              frequency: frequency,
              scheduleStartTime: scheduleStartTime,
              scheduleError: scheduleError
            }), chargeAmount > 0 && scheduleStartTime && scheduleEndTime && /*#__PURE__*/(0,jsx_runtime.jsx)(GiftCardScheduler_GiftCardSummaryText, {
              price: formik.values.amount,
              amount: formik.values.quantity,
              startDateTime: scheduleStartTime,
              endDateTime: scheduleEndTime,
              chargeAmount: chargeAmount
            })]
          }), scheduleType === "Scheduled" && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledScheduleWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Calendar/* default */.Z, {
              date: date,
              setDate: setDate,
              type: "schedule"
            }), scheduleTypeError && !date && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledScheduleError, {
              children: scheduleTypeError
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PurchaseProcess_StyledFieldWrapper, {
            children: [selectedMode === "full" && /*#__PURE__*/(0,jsx_runtime.jsx)(PurchasePage_OtherPersonFields, {
              formatPhoneNumber: Functions/* formatPhoneNumber */.un,
              saveGiftCardData: saveGiftCardData,
              regex: regex
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PurchasePage_MyPersonalFields, {
              selectedMode: selectedMode,
              formatPhoneNumber: Functions/* formatPhoneNumber */.un,
              regex: regex
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LegalCheckboxes/* default */.Z, {
            saveGiftCardData: saveGiftCardData
          }), pastTimeError ? /*#__PURE__*/(0,jsx_runtime.jsx)(PurchaseProcess_StyledError, {
            children: pastTimeError
          }) : !formik.isValid && formik.submitCount ? /*#__PURE__*/(0,jsx_runtime.jsx)(PurchaseProcess_StyledError, {
            children: showOveralError(formik.touched)
          }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButtonBox, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(GenericButton/* default */.Z, {
              btnType: "filled",
              width: 328,
              onClick: function onClick(e) {
                e.preventDefault(); // If the amount is empty, focus the amount field and show an error message.

                if (!formik.values.amount) {
                  var _document$querySelect;

                  setNoValueValidation(true);
                  var amountElLabel = (_document$querySelect = document.querySelector("[name='amount']")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.nextSibling;
                  amountElLabel.focus();
                  return;
                }

                if (scheduleType === "Scheduled") {
                  if (!date) {
                    setScheduleTypeError("שדה זה הינו שדה חובה");
                    return;
                  }

                  if (date) {
                    setScheduleTypeError(null);
                  }
                }

                if (scheduleType === "Allowance") {
                  if (!scheduleStartTime || !scheduleEndTime || !frequency) {
                    setScheduleError("שדה זה הינו שדה חובה");
                    return;
                  }

                  if (new Date(scheduleStartTime) < new Date()) {
                    setPastTimeError("יש לבחור מועד עתידי לשליחת הגיפטקארד");
                    return;
                  }

                  if (scheduleEndTime && scheduleStartTime && frequency) {
                    setScheduleError(null);
                  }

                  if (new Date(scheduleStartTime) > new Date()) {
                    setPastTimeError(null);
                  }
                } // Otherwise, submit the form.


                formik.handleSubmit();
              },
              type: "submit",
              isdisabled: !(buttonValid(formik.isValid, formik.touched, parseInt(formik.values.amount.toString().replace(/[₪]/g, ""))) && (scheduleType === "Scheduled" ? date ? true : false : scheduleType === "Allowance" ? scheduleEndTime && scheduleStartTime && frequency && new Date(scheduleStartTime) > new Date() ? true : false : true)),
              children: "\u05D4\u05DE\u05E9\u05DA \u05DC\u05E1\u05D9\u05DB\u05D5\u05DD \u05E4\u05E8\u05D8\u05D9\u05DD"
            })
          })]
        });
      }
    })]
  });
};

/* harmony default export */ var PurchasePage_PurchaseProcess = (PurchaseProcess);
;// CONCATENATED MODULE: ./src/pages/giftcard/[giftcardName].tsx








var GiftcardName = function GiftcardName(_ref) {
  var giftCard = _ref.giftCard,
      setting = _ref.setting,
      seo = _ref.seo;

  var _useState = (0,react.useState)([]),
      refList = _useState[0],
      setRefList = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(KeyboardNavigation/* default */.Z, {
      refList: refList
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
      data: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PurchasePage_PurchaseProcess, {
      giftCard: giftCard,
      setting: setting,
      setRefList: setRefList
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ var _giftcardName_ = (GiftcardName);

/***/ }),

/***/ 90492:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giftcard/[giftcardName]",
      function () {
        return __webpack_require__(24300);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,2726,3450,2198,7072,4678,2626,3980,7870,8866,9774,2888,179], function() { return __webpack_exec__(90492); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);